const PropertyTypesSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            We Buy <strong>All Property Types</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From single-family homes to multi-unit properties, we purchase all types of real estate in El Paso
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/ba5c6beb0f4910eb29fcbe095adae1a7.jpg"
              alt="Single family home El Paso"
              className="w-full h-64 object-cover"
            />
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-3 text-gray-900">Single-Family Homes</h3>
              <p className="text-gray-700 leading-relaxed">
                Whether it's a starter home, a family residence, or a luxury property, we buy single-family homes throughout El Paso. From 2-bedroom bungalows to 5-bedroom estates, we're interested in properties of all sizes and price ranges.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=multi-family%20apartment%20building%20in%20El%20Paso%20Texas%2C%20duplex%20or%20fourplex%20property%2C%20southwestern%20architectural%20style%2C%20multiple%20units%20visible%2C%20parking%20area%2C%20desert%20landscape%2C%20investment%20property%2C%20professional%20real%20estate%20photography&width=800&height=500&seq=elpasoprop002&orientation=landscape"
              alt="Multi-family property El Paso"
              className="w-full h-64 object-cover"
            />
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-3 text-gray-900">Multi-Family Properties</h3>
              <p className="text-gray-700 leading-relaxed">
                Duplexes, triplexes, fourplexes, and small apartment buildings—we purchase multi-unit properties regardless of occupancy status. Whether fully rented, partially vacant, or completely empty, we can make you an offer.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=mobile%20manufactured%20home%20in%20El%20Paso%20Texas%2C%20well-maintained%20mobile%20home%20park%2C%20southwestern%20desert%20setting%2C%20affordable%20housing%2C%20clean%20exterior%2C%20landscaped%20lot%2C%20blue%20sky%20background%2C%20residential%20community%20atmosphere&width=800&height=500&seq=elpasoprop003&orientation=landscape"
              alt="Mobile home El Paso"
              className="w-full h-64 object-cover"
            />
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-3 text-gray-900">Mobile & Manufactured Homes</h3>
              <p className="text-gray-700 leading-relaxed">
                We buy mobile and manufactured homes on owned or leased land. These properties can be challenging to sell traditionally, but we specialize in finding solutions for mobile home owners throughout El Paso County.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=vacant%20land%20lot%20in%20El%20Paso%20Texas%2C%20undeveloped%20property%20with%20mountain%20views%2C%20desert%20terrain%2C%20residential%20zoning%2C%20investment%20opportunity%2C%20clear%20blue%20sky%2C%20Franklin%20Mountains%20in%20distance%2C%20real%20estate%20development%20potential&width=800&height=500&seq=elpasoprop004&orientation=landscape"
              alt="Vacant land El Paso"
              className="w-full h-64 object-cover"
            />
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-3 text-gray-900">Vacant Land</h3>
              <p className="text-gray-700 leading-relaxed">
                Have a vacant lot you're not using? We purchase residential and commercial land throughout El Paso. Whether it's a small city lot or several acres in the county, we're interested in making you an offer.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h3 className="text-3xl font-bold mb-8 text-gray-900 text-center">
            Special Situation Properties
          </h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="text-xl font-bold mb-4 text-gray-900">We Specialize In:</h4>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Distressed Properties:</strong> Fire damage, water damage, foundation issues, or structural problems—we buy homes that need major repairs.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Inherited Homes:</strong> Dealing with an estate? We make the process simple and can work with multiple heirs.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Foreclosure Properties:</strong> Facing foreclosure? We can often close quickly enough to help you avoid it.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Divorce Situations:</strong> Need to sell quickly as part of a divorce settlement? We provide fast, fair solutions.</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-xl font-bold mb-4 text-gray-900">Also Buying:</h4>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Rental Properties:</strong> Tired of being a landlord? We buy occupied or vacant rental properties.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Hoarder Houses:</strong> Properties with excessive clutter or hoarding situations—no cleanup required.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Title Issues:</strong> Clouded title, liens, or legal complications? We have experience resolving these problems.</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-line text-xl text-teal-600 mr-3 flex-shrink-0 mt-1"></i>
                  <span className="text-gray-700"><strong>Code Violations:</strong> Properties with city code violations or unpermitted work—we can handle it.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertyTypesSection;
